import PropTypes from "prop-types";
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import PayloadsRowMenu from './PayloadsRowMenu';
import { PrimarySearchItems, SecondarySearchItems } from "./PayloadSearchForm";
import ax from '../../util/axios';
import wrap from '../../util/wrap_with_intl_provider';
import SearchBar from "../../../../../components/SearchBar";
import Table from '../../../../../components/Table';
import {
  admin_area_payloads_path,
  admin_area_simulation_path,
  admin_area_unit_path
} from '../../../../../routes';

const PayloadTable = (props) => {

  const intl = useIntl();
  const [pagination, setPagination] = useState({});
  const [payloads, setPayloads] = useState([]);
  const [searchParams, setSearchParams] = useState({});

  const fetchPayloads = async (page = 1) => {
    const response = await ax.get(admin_area_payloads_path({ format: 'json', page, ...searchParams }));
    setPagination(response.data.pagination);
    setPayloads(response.data.payloads);
  };

  const payloadColumns = [
    {
      accessor: 'unitLink',
      className: 'link',
      header: intl.formatMessage({ id: 'admin-area.payloads.unit-field' }),
    },
    {
      accessor: 'simulationLink',
      className: 'link',
      header: intl.formatMessage({ id: 'simulations.search.simulation-name-field' }),
    },
    {
      accessor: 'organisationLink',
      className: 'link',
      header: intl.formatMessage({ id: 'admin-area.payloads.organisation-field' }),
    },
    {
      accessor: 'status',
      header: intl.formatMessage({ id: 'admin-area.payloads.status-field' }),
    },
    {
      accessor: 'test',
      header: intl.formatMessage({ id: 'admin-area.payloads.test-field' }),
    },
    {
      accessor: 'validationErrors',
      header: intl.formatMessage({ id: 'admin-area.payloads.validation-errors-field' }),
    },
    {
      accessor: 'createdAt',
      header: intl.formatMessage({ id: 'admin-area.payloads.created-time-field' }),
    },
    {
      accessor: 'isAuthenticated',
      header: intl.formatMessage({ id: 'admin-area.payloads.is-authenticated-field' }),
    },
    {
      className: 'actions',
      accessor: 'rowMenu',
    },
  ];

  const mappedPayloads = payloads?.map((item) => ({
    ...item,
    rowMenu: <PayloadsRowMenu payload={item.payload}/>,
    unitLink: item.unitId !== null && typeof item.unitName === 'string'
      ? <a href={admin_area_unit_path(item.unitId)}>{item.unitName}</a>
      : null,
    organisationLink: item.organisationId !== null && typeof item.organisationName === 'string'
      ? <a href={admin_area_simulation_path(item.organisationId)}>{item.organisationName}</a>
      : null,
    simulationLink: item.simulationId !== null && typeof item.scenarioName === 'string'
      ? <a href={admin_area_simulation_path(item.simulationId)}>{item.scenarioName}</a>
      : null,
    test: typeof item.test === 'boolean' ? String(item.test) : item.test,
    isAuthenticated: typeof item.isAuthenticated === 'boolean' ? String(item.isAuthenticated) : item.isAuthenticated,
  }));

  useEffect(() => {
    fetchPayloads();
  }, [searchParams]);

  return (
    <div>
      <SearchBar
        primaryItems={<PrimarySearchItems />}
        secondaryItems={props.organisations && (<SecondarySearchItems organisations={props.organisations} />)}
        onSearch={setSearchParams}
      />
      {payloads?.length > 0 && (
        <Table
          header={true}
          items={mappedPayloads}
          columns={payloadColumns}
          pagination={pagination}
          onPageChange={fetchPayloads}
        />
      )}
    </div>
  );
};

PayloadTable.propTypes = {
  organisations: PropTypes.array.isRequired,
};

export default wrap(PayloadTable);
